//
import { LangComJa } from '@/locales/lang-com-ja';
export const ja = {
  com: LangComJa,
  seo: {
    title: 'INSPIRE LLC Webサイト:お問合せ',
    description: `[INSPIRE LLC] 自動車流通業界のプロフェッショナルギルドへお問合せ`,
    keywords: `INSPIRE LLC,インスパイア,自動車,輸出,貿易,中古車,東京,システム,エンジニア,問い合わせ`,
  },
  title: `お問い合わせ`,
  formLabel: {
    name: `お名前（必須）`,
    company: `会社名`,
    email: `メールアドレス（必須）`,
    tel: `電話番号`,
    message: `お問い合わせ内容（必須）`,
    check: `上記プライバシーポリシーについて同意する`,
    checkBtn: `送信内容確認`,
    requireMessage: `この項目は必須項目です`,
    emailError: `メールアドレスを入力してください`,
  },
  checkModal: {
    title: `送信内容の確認`,
    note: `以下の内容で送信してよろしいですか？`,
    send: `質問送信`,
  },
  requestSend: {
    connectionError: `通信に失敗しました。`,
    requestError: `送信失敗`,
    requestCompleted: `送信完了`,
  },
  PrivacyPolicy: {
    title: `プライバシーポリシー`,
    subTitle: `INSPIRE合同会社（以下「当社」）は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、
    全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。`,
    r1: {
      title: `個人情報の管理`,
      text: `当社は、お客さまの個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。`,
    },
    r2: {
      title: `個人情報の利用目的`,
      text: `お客さまからお預かりした個人情報は、当社からのご連絡や業務のご案内やご質問に対する回答として、電子メールや資料のご送付に利用いたします。`,
    },
    r3: {
      title: `個人情報の第三者への開示・提供の禁止`,
      text: `当社は、お客さまよりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。`,
      list1: `お客さまの同意がある場合`,
      list2: `お客さまが希望されるサービスを行なうために当社が業務を委託する業者に対して開示する場合`,
      list3: `法令に基づき開示することが必要である場合`,
    },
    r4: {
      title: `個人情報の安全対策`,
      text: `当社は、個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じています。`,
    },
    r5: {
      title: `ご本人の照会`,
      text: `お客さまがご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。`,
    },
    r6: {
      title: `法令、規範の遵守と見直し`,
      text: `当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。`,
    },
    r7: {
      title: `お問い合せ`,
      text: `当社の個人情報の取扱に関するお問い合せは下記までご連絡ください。`,
    },
    info: {
      name: 'INSPIRE合同会社',
      address: '〒124-0013 東京都葛飾区東立石3丁目11番7号',
      mail: 'メールアドレス:',
    },
  },
};
